module.exports = {
  home: {
    text1: '欢迎使用',
    text2: '本次登录IP',
    text3: '本次登录时间',
    text4: '上次登录IP',
    text5: '上次登录时间',
    text6: '最近一周数据统计',
    text7: '用户注册数',
    text8: '订单数',
    text9: '本后台系统由上海米因大数据科技开发团队 技术支持',
  },
  admin: {
    t1: '菜单列表',
    t2: '新增菜单',
    t3: '修改菜单',
    t4: '菜单名称',
    t5: '所属一级菜单',
    t6: '图标',
    t7: '路由',
    t8: '排序',
    t9: '是否显示',
    t10: '编号',
    t11: '操作',
    t12: '英文名称',
  },
  goods: {
    t1: '商品管理',
    t2: '添加商品',
    t3: '编号',
    t4: '商品图',
    t5: '名称',
    t6: '价格',
    t7: '市场价格',
    t8: '验血价格',
    t9: '状态',
    t10: '操作日期',
    t11: '操作',
    t12: '排序',
    t13: '历史图库',
    t14: '添加',
    t15: '修改',
    t16: '请输入',
    t17: '提交',
    t18: '取消',
    t19: '商品',
    t20: '图片',
    t21: '请输入名称',
    t22: '请输入价格',
    t23: '请输入市场价格',
    t24: '代码',
  },
  open: {
    a1: '该套餐仅适用于年龄在20~90周岁之间人群!',
    a2: '该套餐仅适用于年龄在40~80周岁之间人群!',

    t1: '个人信息',
    t2: '问卷信息',
    t3: '体型信息',
    t4: '生化信息',
    t5: '手机号',
    t6: '企业用户ID',
    t7: '用户性别',
    t8: '出生日期',
    t9: '报告单位',
    t10: '体检日期',
    t11: '产品内容',
    t12: '上一步',
    t13: '下一步',
    t14: '男',
    t15: '女',
    t16: '一、基本资料',
    t17: '1.客户的居住地',
    t18: '2.客户的喝酒情况（单选）？',
    t19: '3.客户是否吸烟（单选）？',
    t20: '4.客户的用餐习惯（单选）？',
    t21: '5.客户是否是全日素食者（单选）？',
    t22: '6.客户的运动习惯（单选）？',
    t23: '7.客户是否有睡眠障碍（单选）？',
    t24: '8.客户是否患有以下疾病？',
    t25: '9.客户是否做过下列手术？',
    t26: '10.客户的直系亲属有下列疾病吗？',
    t27: '二、个人病史',
    t28: '三、个人手术史',
    t29: '四、家族病史',
    t30: '身高',
    t31: '体重',
    t311: '胸围',
    t32: '腰围',
    t33: '臀围',
    t34: '体脂率',
    t35: '若不填体脂率,则根据您的信息自动生成',
    t36: '血压检查',
    t37: '血常规检查',
    t38: '血糖检查',
    t39: '血脂检查',
    t40: '肝功能检查',
    t41: '肾功能检查',
    t42: '收缩压(SBP)',
    t43: '舒张压(DBP)',
    t44: '白细胞(WBC)',
    t45: '血红蛋白(HGB)',
    t46: '血小板(PLT)',
    t47: '空腹血糖(FG)',
    t48: '糖化血红蛋白(HBA1C)',
    t49: '总胆固醇(CHOL)',
    t50: '低密度脂蛋白(LDLC)',
    t51: '高密度脂蛋白(HDLC)',
    t52: '甘油三酯(TG)',
    t53: '谷草转氨酶（GOT/AST）',
    t54: '谷丙转氨酶（GPT/ALT）',
    t55: '碱性磷酸酶(ALP)',
    t56: '血清白蛋白(ALB)',
    t57: '肌酐(CRE)',
    t58: '尿酸(UA)',
    t59: '肾小球滤过率(EGFR)',
    t60: '选填',
    t61: '确认提交',
    t62: '妈妈信息',
    t63: '宝宝信息',
    t64: '骨折问卷',
    t65: '产品选择',

    q1: '不喝',
    q2: '天天喝',
    q3: '经常喝',
    q4: '偶尔喝',
    q5: '不吸',
    q6: '天天吸',
    q7: '经常吸',
    q8: '偶尔吸',
    q9: '定时定量',
    q10: '不定时不定量',
    q11: '定时不定量',
    q12: '不定时但定量',
    q13: '不是',
    q14: '是',
    q15: '没有或每周少于一小时',
    q16: '每周运动1~2小时',
    q17: '每周运动3~4小时',
    q18: '每周运动5~6小时',
    q19: '每周运动7小时以上',
    q20: '没有',
    q21: '非常严重',
    q22: '经常',
    q23: '偶尔',
    q24: '否',
    q25: '是，请选择服药情况（多选）',
    q26: '疾病名称',
    q27: '不服药',
    q28: '偶尔服药',
    q29: '经常服药',
    q30: '是，请选择（多选）',

    f1: '4.客户曾经是否骨折（单选）？',
    f2: '5.客户父母是否曾经髋部骨折（单选）？',
    f3: '6.客户的日常生活与事务决定处理与认知能力？（单选）？',
    f4: '7.股骨颈骨密度（BMD）？',
    f5: '8.客户是否患过以下疾病？',
    f6: '9.客户是否需要医护服务？',

    f7: '不知道',
    f8: '自主决定，一直且合理',
    f9: '部分自主，遇到新状况会有困难',
    f10: '多数情况无法自主、或决定欠佳、或需提示',
    f11: '不知道',
    f12: '请填写客户曾经骨折次数',
    f13: '请输入骨密度',
    f14: '请选择客户是否患有以下疾病',
    f15: '请选择客户的居住地',
    f16: '请选择客户的喝酒情况',
    f17: '请选择客户是否吸烟',
    f18: '请选择客户曾经是否存骨折',
    f19: '请选择客户父母是否曾经髋部骨折',
    f20: '请选择客户生活自主认知能力',
    f21: '请填写客户骨密度值',
    f22: '请填写客户曾经骨折次数',

    f23: '没有',
    f24: '有',

    f25: '请输入手机号',
    f26: '请输入企业用户ID',
    f27: '手机号与企业用户ID至少填写一项',
    f28: '请选择',
    f29: '请选择出生日期',
    f30: '请选择体检日期',
    f31: '体检日期大于出生日期且不能大于当前时间',
    f32: '请选择套餐',
    f33: '请选择开通套餐',
    f34: '请选择客户的用餐习惯',
    f35: '请选择客户是否为全日素食者',
    f36: '请选择客户的运动习惯',
    f37: '请选择客户是否存在睡眠障碍',
    f38: '请选择服药情况',
    f39: '请填写您的身高',
    f40: '请填写您的体重',
    f41: '请输入身高',
    f42: '请输入体重',
    f43: '若不填腰围,则根据您的信息自动生成',
    f44: '若不填臀围,则根据您的信息自动生成',
    f45: '若不填体脂率,则根据您的信息自动生成',
    f46: '不能为空',
    f47: '请输入（选填）',
    f48: '请输入白细胞',
    f49: '请选择客户性别',
    f50: '请输入腰围',
    f51: '请输入臀围',
    f52: '请输入胸围',
    f53: '请填写您的胸围',

    f54: '身高为130~200',
    f55: '体重为30~160',
    f56: '胸围为40~165',
    f57: '腰围为40~150',
    f58: '臀围为60~165',
    f59: '体脂率为3~75',

    f60: '确认输入信息',
    f61:
      '您填写的结果可能存在较大偏差，请您仔细核对该数值和所用单位是否正确并与您的报告一致。<br/>若您已经核对确认，并坚持以该结果进行提交和评估，我们可能会根据AI算法对该结果进行一定程度上的修正和处理，以提供更合理的大数据评估结果和建议。',
    resetForm: '上一步',
    t71: '填写生化信息',
    t72: '请填写任意一项',
  },
  table: {
    t1: '编号',
    t2: '手机号/企业用户ID',
    t3: '产品内容',
    t4: '性别',
    t5: '出生日期',
    t6: '体检时间',
    t7: '状态',
    t8: '次数',
    t9: '操作',
    t10: '操作人',
    t11: '操作时间',
    t12: '开始日期',
    t13: '结束日期',
    t14: '全部套餐',
    t15: '创建日期',
    t16: '企业名称',
    t17: '付费方式',
    t18: '使用次数',
    t19: '剩余次数',
    t20: '查看详情',
    t21: '姓名',
    t22: '免费',
    t23: '身份证号',
    t24: '套餐名称',
    t25: '日期',
    t26: '后付费',
    t27: '预付费',
    t28: '消息',
    t29: '设置',
    t30: '退出',
    t31: '侧边栏皮肤',
    t32: '浅色',
    t33: '深色',
    t34: '总',
    t35: '共',

    t36: '已完成',
    t37: '未完成',
    t38: '修改',
    t39: '查询',
    t40: '重置',
    t41: '查看',
    t42: '下载',

    t43: '请输入手机号/企业用户ID',

    t44: '开通',
    t45: '次',

    t46: '语言',
  },
  // area: {
  // 	c1: "江苏省",
  // 	c2: "上海市",
  // 	c3: "北京市",
  // 	c4: "天津市",
  // 	c5: "浙江省",
  // 	c6: "广东省",
  // 	c7: "辽宁省",
  // 	c8: "山东省",
  // 	c9: "内蒙古自治区",
  // 	c10: "重庆市",
  // 	c11: "福建省",
  // 	c12: "海南省",
  // 	c13: "湖北省",
  // 	c14: "湖南省",
  // 	c15: "陕西省",
  // 	c16: "河南省",
  // 	c17: "黑龙江省",
  // 	c18: "青海省",
  // 	c19: "云南省",
  // 	c20: "安徽省",
  // 	c21: "四川省",
  // 	c22: "贵州省",
  // 	c23: "甘肃省",
  // 	c24: "江西省",
  // 	c25: "吉林省",
  // 	c26: "山西省",
  // 	c27: "河北省",
  // 	c28: "宁夏回族自治区",
  // 	c29: "广西壮族自治区",
  // 	c30: "新疆维吾尔自治区",
  // 	c31: "西藏自治区",
  // 	c32: "中国台湾",
  // 	c33: "中国香港",
  // },

  // 客户居住地
  areaList: [
    { text: '江苏省', code: '3200' },
    { text: '上海市', code: '3100' },
    { text: '北京市', code: '1100' },
    { text: '天津市', code: '1200' },
    { text: '浙江省', code: '3300' },
    { text: '广东省', code: '4400' },
    { text: '辽宁省', code: '2100' },
    { text: '山东省', code: '3700' },
    { text: '重庆市', code: '5000' },
    { text: '福建省', code: '3500' },
    { text: '海南省', code: '4600' },
    { text: '湖北省', code: '4200' },
    { text: '湖南省', code: '4300' },
    { text: '陕西省', code: '6100' },
    { text: '河南省', code: '4100' },
    { text: '黑龙江省', code: '2300' },
    { text: '青海省', code: '6300' },
    { text: '云南省', code: '5300' },
    { text: '安徽省', code: '3400' },
    { text: '四川省', code: '5100' },
    { text: '贵州省', code: '5200' },
    { text: '甘肃省', code: '6200' },
    { text: '江西省', code: '3600' },
    { text: '吉林省', code: '2200' },
    { text: '山西省', code: '1400' },
    { text: '河北省', code: '1300' },
    { text: '宁夏回族自治区', code: '6400' },
    { text: '广西壮族自治区', code: '4500' },
    { text: '新疆维吾尔自治区', code: '6500' },
    { text: '内蒙古自治区', code: '1500' },
    { text: '西藏自治区', code: '5400' },
    { text: '中国台湾', code: '0000' },
    { text: '中国香港', code: '4401' },
  ],

  diseases: {
    d1: '高血压',
    d2: '高血脂',
    d3: '糖尿病',
    d4: '慢性肝病',
    d5: '慢性肾脏病',
    d6: '癌症',
    d7: '肝硬化',
    d8: '慢性阻塞性肺炎',
    d9: '关节炎',
    d10: '心脏病',
    d11: '脑中风',
    d12: '胃肠溃疡',
    d13: '睡眠障碍',
    d14: '贫血',
    d15: '疼痛',
    d16: '哮喘',
    d17: '痛风',
    d18: '痔疮',
    d19: '甲状腺疾病',
  },
  oper: {
    d1: '头或脑部',
    d2: '眼鼻耳',
    d3: '口腔、食道',
    d4: '胸部(心、肺等)',
    d5: '腹部(胃、肝、胆等)',
    d6: '关节与骨',
    d7: '妇科手术',
    d8: '泌尿系统',
  },
  famdis: {
    d1: '癌症',
    d2: '脑中风',
    d3: '心肌梗塞',
    d4: '肝硬化',
    d5: '老年失智',
    d6: '慢性阻塞性肺炎',
    d7: '结核病',
    d8: '先天畸形',
  },

  menus: localStorage.getItem('menusList')
    ? JSON.parse(localStorage.getItem('menusList'))
    : [],
}
